import React from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import style from './BackButton.module.scss';
import { useTranslation } from '../../shared/hooks/useTranslation';

interface BackButtonProps {
  /** Куда вести. По умолчанию — на предыдущую страницу в истории. */
  to?: string;
  /** Текст рядом с иконкой. По умолчанию — перевод «Назад». */
  label?: string;
  className?: string;
  onClick?: () => void;
}

export const BackButton: React.FC<BackButtonProps> = ({ to, label, className, onClick }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    if (to) {
      navigate(to);
      return;
    }
    navigate(-1);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={clsx(style.backButton, className)}
      aria-label={label ?? t.back}
    >
      <ArrowLeftOutlined className={style.icon} />
      <span className={style.label}>{label ?? t.back}</span>
    </button>
  );
};
